import React from 'react';
import { Link } from 'react-router-dom';
import { modelMap } from 'shared/utils';
import { getTenantPath } from 'shared/routes/tenant';

/**
 * @param {Object} props
 * @param {string} props.ruleType - One of: 'tenant', 'property', 'complex', 'manager', 'global'
 * @param {Array<Object>} [props.rules=[]]
 * @param {number} [props.tenantId=0]
 * @param {string} [props.tenantName='']
 */
export default function CouponApplicableBy(props) {
  const {
    ruleType,
    tenantId = 0,
    tenantName = '',
    rules = [],
  } = props;

  if (ruleType === 'tenant' && !tenantId) return 'Select a tenant';

  if (ruleType === 'tenant') {
    return <Link to={getTenantPath(tenantId)}>{tenantName}</Link>;
  }

  if (rules.length === 0) return 'Everyone';

  const model = modelMap[ruleType];
  if (rules.length === 1) return <Link to={model.getView(rules[0].id)}>{rules[0].name}</Link>;

  const rulesRef = [];

  for (let i = 0; i < rules.length; i += 1) {
    if (i === rules.length - 1) {
      rulesRef.push({ id: rules[i].id, name: rules[i].name });
    } else {
      const ruleName = `${rules[i].name}, `;
      rulesRef.push({ id: rules[i].id, name: ruleName });
    }
  }

  return (
    <>
      {rulesRef.map((item) => (
        <Link key={item.id} to={model.getView(item.id)}>{item.name}</Link>))}
    </>
  );
}
